import * as React from 'react';
import {Enter} from './enter';
import {LoginState} from '../../shared/models/login/loginStep';
import {Login} from './login';
import {RegistrationOrRecovery} from './registratonOrRecovery';
import {PhoneCheck} from './phoneCheck';
import {useSelector} from 'react-redux';
import {LoginStepSelector} from '../../redux/selectors/runtime/loginStep';
import {LoginLayout} from './components/layout';
import {loginResponseSelector} from '../../redux/selectors/login';
import {LoginType} from '../../shared/models/api';
import {useDeviceSize} from '../../shared/theme/helpers';

export default () => {
  const step = useSelector(LoginStepSelector());
  const loginResponse = useSelector(loginResponseSelector());
  const deviceSize = useDeviceSize();

  const showBackButton = React.useMemo(() => {
    return (
      step !== LoginState.enter ||
      (step === LoginState.enter && loginResponse && loginResponse.loginType !== LoginType.EskNumber)
    );
  }, [step, loginResponse]);

  const title = React.useMemo(() => {
    if (step === LoginState.login || step === LoginState.enter || step === LoginState.phoneNumberCheck) {
      return 'Вход в личный кабинет';
    } else if (step === LoginState.registrationCode || step === LoginState.registrationPasswords) {
      return 'Регистрация';
    } else if (step === LoginState.agreement) {
      return 'Согласие на обработку персональных данных';
    }
    return 'Восстановление пароля';
  }, [step]);

  const showHelpText = React.useMemo(() => {
    if (step === LoginState.enter) {
      if (loginResponse && loginResponse.loginType !== LoginType.EskNumber) {
        return false;
      }
      return true;
    }
    return false;
  }, [step, deviceSize, loginResponse]);

  const minHeightMobile = step === LoginState.enter ? 320 : step === LoginState.login ? 420 : 370;

  return (
    <LoginLayout
      useBackButton={!!showBackButton}
      title={title}
      showHelpText={showHelpText}
      minHeightMobile={minHeightMobile}>
      {step === LoginState.enter ? <Enter /> : null}
      {step === LoginState.login ? <Login /> : null}
      {step === LoginState.phoneNumberCheck ? <PhoneCheck /> : null}
      {step !== LoginState.enter && step !== LoginState.login && step !== LoginState.phoneNumberCheck ? (
        <RegistrationOrRecovery />
      ) : null}
    </LoginLayout>
  );
};
